import axios from 'axios';
// const cancelAllTokens = axios.CancelToken;
// const cancelAllTokensSource = cancelAllTokens.source();

axios.interceptors.request.use(
	config => {
		const headers = config.headers || {};
		config = {
			...config,
			headers: {
				...headers,
				// source: cancelAllTokensSource.token,
				'X-Requested-With': 'XMLHttpRequest'
			}
		};
    return config;
  },
  error => {
    return Promise.reject(error);
  });

axios.interceptors.response.use(
	response => {
		return response;
	},
	error => {
		// let error_message = false;
		if (error.response) {
	  	// cancelAllTokensSource.cancel();
	  	// error_message = 'لطفا دوباره وارد شوید.';
		} else if (error.request) {
		    // The request was made but no response was received
		    // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
		    // http.ClientRequest in node.js
		} else {
		    // Something happened in setting up the request that triggered an Error
		    // error_message = error.message;
		}
		return Promise.reject(error);
	});

export default axios;